import type { InvestorType } from '@workspace/api-backend'

export const GEO_LABELS: Record<string, string> = {
  global: 'Global',
  north_america: 'North America',
  europe: 'Europe',
  asia_pacific: 'Asia Pacific',
  latin_america: 'Latin America',
  middle_east: 'Middle East',
  africa: 'Africa',
}

export const STAGE_LABELS: Record<string, string> = {
  PRE_SEED: 'Pre-seed',
  SEED: 'Seed',
}

export const INVESTOR_TYPE_LABELS: Record<InvestorType, string> = {
  VC_FUND: 'VC Fund',
  ANGEL: 'Angel',
  ACCELERATOR: 'Accelerator',
  VENTURE_STUDIO: 'Venture Studio',
  AGENT_ADVISOR: 'Agent / Advisor',
}

export function formatTicket(min: number | null, max: number | null): string {
  const fmt = (n: number) => (n >= 1_000_000 ? `$${n / 1_000_000}M` : `$${n / 1_000}k`)
  if (min != null && max != null) return `${fmt(min)}–${fmt(max)}`
  if (min != null) return `${fmt(min)}+`
  if (max != null) return `up to ${fmt(max)}`
  return ''
}

export const SECTOR_LABELS: Record<string, string> = {
  ai_ml: 'AI / ML',
  saas: 'SaaS',
  fintech: 'Fintech',
  healthtech: 'HealthTech',
  edtech: 'EdTech',
  cleantech: 'CleanTech',
  proptech: 'PropTech',
  legaltech: 'LegalTech',
  insurtech: 'InsurTech',
  deeptech: 'DeepTech',
  biotech: 'Biotech',
  ecommerce: 'E-commerce',
  marketplace: 'Marketplace',
  gaming: 'Gaming',
  media: 'Media',
  crypto: 'Crypto',
  web3: 'Web3',
  ai: 'AI',
  cybersecurity: 'Cybersecurity',
  logistics: 'Logistics',
  hrtech: 'HRTech',
  adtech: 'AdTech',
  agritech: 'AgriTech',
  foodtech: 'FoodTech',
  mobility: 'Mobility',
  hardware: 'Hardware',
  enterprise: 'Enterprise',
  consumer: 'Consumer',
  other: 'Other',
}
